'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Heading;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('../../styles/scss/global.scss');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function Heading(props) {
  var text = props.text,
      size = props.size,
      heading = props.heading,
      color = props.color;

  switch (heading) {
    case 'h1':
      return _react2.default.createElement('h1', {
        className: 'heading-' + size + ' text-' + color + '-color'
      }, text);

    case 'h2':
      return _react2.default.createElement('h2', {
        className: 'heading-' + size + ' text-' + color + '-color'
      }, text);

    case 'h3':
      return _react2.default.createElement('h3', {
        className: 'heading-' + size + ' text-' + color + '-color'
      }, text);

    default:
      return _react2.default.createElement('h1', {
        className: 'heading-' + size + ' text-' + color + '-color'
      }, text);
  }
}

Heading.propTypes = {
  /** Text for heading */
  text: _propTypes2.default.string.isRequired,

  /** Size of heading */
  size: _propTypes2.default.oneOf(['small', 'medium', 'large', 'x-large']),

  /** h tag to use */
  heading: _propTypes2.default.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6'])
};
Heading.defaultProps = {
  heading: 'h1',
  size: 'medium'
};